import React from 'react'

const About = () => {
  return (
    <div className='flex justify-center py-10'>
      <p>Streaming Website</p>
      <p>Created as a project</p>
      <p>TODO: add search</p>
      <p>TODO: Make about page</p>
      <p>TODO: change videos tab</p>
      <p>TODO: Update UI</p>
    </div>
  )
}

export default About
